import { ValidatorFn, FormGroup, AbstractControl, ValidationErrors } from "@angular/forms";
import { numericRegEx, alphabeticRegEx, alphabeticOrNumeric, emptyOrAlphabetic, noBlankFieldRegEx } from "./regex";
import moment from "moment";


export function atLeastOne (validator: ValidatorFn, controls:string[]) {
    return (group: FormGroup): ValidationErrors | null => {
        let hasAtLeastOne = true;
        if(!controls){controls = Object.keys(group.controls)}
        hasAtLeastOne = group && group.controls && controls.some(k => !validator(group.controls[k])); 
        return !hasAtLeastOne ?  { atLeastOne: true } : null;
    }
}

export function noBlankFieldValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) { return null; }
        const noBlankField = noBlankFieldRegEx.test(value)
        return !noBlankField ? { blankField: true } : null;
    }
}

export function claimNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const claimNumber = control.value;
        if (!claimNumber) { return null; }
        const firstTwoDigits = numericRegEx.test(claimNumber.substring(0,2))
        const restDigits = alphabeticRegEx.test(claimNumber.substring(2,10))
        const correctFormat = firstTwoDigits && !restDigits
        return !correctFormat ? { incorrectFormat: 'Incorrect format.  Enter a valid Claim Number in 99-XXXX-XXX format.' } : null;
    }
}

export function policyNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const policyNumber = control.value;
        if (!policyNumber) { return null; }
        const basic = alphabeticOrNumeric.test(policyNumber.substring(0,7))
        const renewalMonth = alphabeticRegEx.test(policyNumber.substring(7,8))
        const renewalDay = numericRegEx.test(policyNumber.substring(8,10))
        const stateCode = numericRegEx.test(policyNumber.substring(10,12))
        const changeCode = emptyOrAlphabetic.test(policyNumber.substring(12,13))
        const correctFormat = basic && renewalMonth && renewalDay && stateCode && changeCode
        return !correctFormat ? { incorrectFormat: 'Incorrect format. Please enter a valid Policy Number in XXXXXXX-A99-99A format.' } : null;
    }
}

export function dateOfLossValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const dol = control.value;
        if (!dol) { return null; }
        const date = moment(dol, "MM-DD-YYYY")
        const incorrectDate = date.isValid()
        return !incorrectDate ? { incorrectDate: true
     } : null;
    }
}

export function futureDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const dol = control.value;
        if (!dol) { return null; }
        const todaysDate = new Date()
        const futureDate = moment(new Date(dol)).isAfter(todaysDate)
        return futureDate ? { futureDate: true,
     } : null;
    }
}